import { BasicPlanCard } from "@components/_subscription/basic-plan-card/BasicPlanCard"
import { BusinessPlanCard } from "@components/_subscription/business-plan-card/BusinessPlanCard"
import { EnterprisePlanCard } from "@components/_subscription/enterprise-plan-card"
import { FreePlanCard } from "@components/_subscription/free-plan-card"
import { SubscriptionGrid } from "@components/_subscription/SubscriptionGrid"
import { CurrencyDropdownMenu } from "@components/app/app-header/currency-dropdown-menu"
import { Container } from "@components/ui/Container"
import { Heading } from "@components/ui/typograhpy/Heading"
import { PricingSingleton } from "__generated__/sanity"
import React, { FC } from "react"

type PricingPageHeroProps = PricingSingleton["fields"]["hero"]

export const PricingPageHero: FC<PricingPageHeroProps> = ({ title }) => {
  return (
    <Container
      size="medium"
      className="mb-30 pt-20 md:mb-44 md:pt-24 lg:mb-50 lg:pt-40"
    >
      <Heading
        variant="h1"
        as="h1"
        className="mb-16 text-center whitespace-pre-line lg:mb-24"
      >
        {title}
      </Heading>
      <div className="mb-4 flex w-full justify-center">
        <CurrencyDropdownMenu />
      </div>

      <SubscriptionGrid>
        <FreePlanCard variant="static" />
        <BasicPlanCard variant="static" />
        <BusinessPlanCard variant="static" />
      </SubscriptionGrid>
      <EnterprisePlanCard />
    </Container>
  )
}
